"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBlockType = exports.getMarkType = void 0;

var getMarkType = function getMarkType(_ref, type) {
  var value = _ref.value;

  if (value.marks.size > 0) {
    return value.marks.filter(function (mark) {
      return mark.type === type;
    });
  }
};

exports.getMarkType = getMarkType;

var getBlockType = function getBlockType(_ref2, type) {
  var value = _ref2.value;

  if (value.blocks.size > 0) {
    return value.blocks.filter(function (block) {
      return block.type === type;
    });
  }
};

exports.getBlockType = getBlockType;